module.exports = __webpack_public_path__ + "img/9788960171411.17e257f0.jpg";